import { render, staticRenderFns } from "./changePasswordDialog.vue?vue&type=template&id=09b563f0&scoped=true"
import script from "./changePasswordDialog.vue?vue&type=script&lang=js"
export * from "./changePasswordDialog.vue?vue&type=script&lang=js"
import style0 from "./changePasswordDialog.vue?vue&type=style&index=0&id=09b563f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b563f0",
  null
  
)

export default component.exports